// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NIFV","comment":"styles_comment__3YUf2"};